import { createFileRoute, redirect } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";

// BEL-466: settings.fsmWorkflows/documentTypes were reclassified to admin.* — these
// objects carry customer_id and are per-customer (ADR-035 §5), not platform-plane.
// Legacy stub for bookmarked/linked URLs.
export const Route = createFileRoute("/app/settings/fsm-workflows")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  beforeLoad: () => {
    throw redirect({ to: "/app/admin/fsm-workflows" });
  },
});
